import { StyledFriendsNearbyButton } from 'common/Buttons/FriendsNearbyButton/styled'

export const FriendsNearbyButton = () => (
  <StyledFriendsNearbyButton>New friends nearby</StyledFriendsNearbyButton>
)
